import { createMemo } from 'solid-js'
import { useService } from 'solid-services'
import { useChannels } from './channels/channels'

export function useSelectors() {
  const { channelsResource } = useService(useChannels)()

  const lastReadFrancisUpdate = () => {
    const francisChannel = channelsResource().find(
      (channel) => channel.name === 'francis-updates',
    )
    if (!francisChannel) return

    return {
      lastReadAt: francisChannel.last_message_at,
      francisChannelId: francisChannel.id
    }
  }

  const setupChannels = createMemo(() => {
    return channelsResource()
      .filter((channel) => channel.type === 'setup')
      .sort((a, b) => {
        const at = a.last_message_at ?? a.created_at
        const bt = b.last_message_at ?? b.created_at
        return Date.parse(bt) - Date.parse(at)
      })
  })

  const generalChannels = createMemo(() => {
    return channelsResource().filter((channel) => channel.type === 'general')
  })

  return {
    lastReadFrancisUpdate,
    setupChannels,
    generalChannels,
  }
}
